import { render, staticRenderFns } from "./Notification.vue?vue&type=template&id=c9fd10a8&scoped=true&"
var script = {}
import style0 from "./Notification.vue?vue&type=style&index=0&id=c9fd10a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9fd10a8",
  null
  
)

export default component.exports